import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const VideoCameraOffIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="28"
    height="28"
    viewBox="0 0 28 28"
    sx={{ fill: 'none' }}
    {...props}
  >
    <path
      opacity="0.2"
      d="M19.25 6.5625H2.625C2.14175 6.5625 1.75 6.95425 1.75 7.4375V20.5625C1.75 21.0457 2.14175 21.4375 2.625 21.4375H19.25C19.7332 21.4375 20.125 21.0457 20.125 20.5625V7.4375C20.125 6.95425 19.7332 6.5625 19.25 6.5625Z"
      fill="white"
    />
    <path
      d="M26.25 19.25L20.125 15.75V12.25L26.25 8.75V19.25Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.81641 2.625L24.4992 25.375"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1289 6.5625H19.2492C19.4813 6.5625 19.7038 6.65469 19.8679 6.81878C20.032 6.98288 20.1242 7.20544 20.1242 7.4375V15.75"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.125 20.5625C20.125 20.7946 20.0328 21.0171 19.8687 21.1812C19.7046 21.3453 19.4821 21.4375 19.25 21.4375H2.625C2.39294 21.4375 2.17038 21.3453 2.00628 21.1812C1.84219 21.0171 1.75 20.7946 1.75 20.5625V7.4375C1.75 7.20544 1.84219 6.98288 2.00628 6.81878C2.17038 6.65469 2.39294 6.5625 2.625 6.5625H7.39375"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
